import AdminListItemModel from '@/models/AdminListItemModel';

export default {
  listItemById: (state: any, getters: any) => (listItemId: number) => {
    const listItem = state.list_items[listItemId];
    if (listItem) {
      return new AdminListItemModel(listItem, getters);
    }
  },
  listItemsByListId: (state: any, getters: any) => (listId: number) => {
    return Object.values(state.list_items)
      .map((listItem: any) => new AdminListItemModel(listItem, getters))
      .filter((listItem: AdminListItemModel) => listItem.listId === listId);
  },
};
